// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  untilEOL = 211,
  untilCommentClose = 212,
  Comment = 1,
  Program = 2,
  EnableDirective = 3,
  Identifier = 4,
  Directive = 5,
  EnableExtension = 6,
  TypeDeclaration = 7,
  Type = 83,
  Keyword = 195,
  IntLiteral = 38,
  UintLiteral = 39,
  Reserved = 105,
  LocalDeclaration = 106,
  GlobalVariableDeclaration = 107,
  AttributeList = 108,
  Attribute = 109,
  FloatLiteral = 110,
  GlobalVariable = 111,
  VariableQualifier = 113,
  VariableIdentifier = 114,
  Assign = 115,
  Sub = 117,
  Boolean = 119,
  GlobalConstantDeclaration = 120,
  LeftBracket = 126,
  RightBracket = 127,
  FieldAccess = 128,
  PrivateIdentifier = 129,
  Bang = 130,
  Tilde = 131,
  Mul = 132,
  And = 133,
  Div = 134,
  Mod = 135,
  Add = 136,
  Left = 137,
  Right = 138,
  Lt = 139,
  Gt = 140,
  Lte = 141,
  Gte = 142,
  Eq = 143,
  Neq = 144,
  OrOr = 145,
  AndAnd = 146,
  Or = 147,
  Xor = 148,
  TypeAliasDeclaration = 149,
  StructDeclaration = 151,
  StructBodyDeclaration = 153,
  StructMember = 154,
  FunctionDeclaration = 155,
  FunctionHeader = 156,
  ParamList = 158,
  Param = 159,
  ReturnType = 160,
  CompoundStatement = 161,
  Statement = 162,
  ContinuingStatement = 171,
  AddAssign = 175,
  SubAssign = 176,
  MulAssign = 177,
  DivAssign = 178,
  ModAssign = 179,
  AndAssign = 180,
  XorAssign = 181,
  OrAssign = 182,
  LeftAssign = 183,
  RightAssign = 184,
  Inc = 185,
  Dec = 186,
  ImportDeclaration = 190,
  ImportDeclarationList = 192,
  ImportDeclarationIdentifier = 193,
  String = 194
